import {
  getAccessibleCunluoAdcdList,
  getAccessibleCunluoNames,
  getDefaultCunluoName
} from '@/config/cunluo'

export const PLATFORM_TITLE_SUFFIX = '历史文化街区风貌监测平台'
export const PLATFORM_TITLE = PLATFORM_TITLE_SUFFIX

function getUserData(userPermission) {
  return userPermission?.data || userPermission || {}
}

export function getUserCountyName(userInfo = {}) {
  const userData = getUserData(userInfo)
  return userData.countyname || userData.adcdname || ''
}

export function getPlatformTitle(userInfo = {}) {
  const countyName = getUserCountyName(userInfo)
  if (!countyName) return PLATFORM_TITLE_SUFFIX
  return `${countyName}${PLATFORM_TITLE_SUFFIX}`
}

export function getVillageAdcdids(userPermission) {
  return getAccessibleCunluoAdcdList(getUserData(userPermission))
    .map(item => item.adcdid)
    .filter(Boolean)
}

export function getVillageFilterOptions(userPermission) {
  return getAccessibleCunluoAdcdList(getUserData(userPermission))
}

export function getDefaultVillageName(userPermission) {
  return getDefaultCunluoName(getUserData(userPermission))
}

export function getVillageSelectOptions(userPermission) {
  return getAccessibleCunluoNames(getUserData(userPermission)).map((name, index) => ({
    id: index + 1,
    value: name,
    label: name
  }))
}
